import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function Dashboard() {
  const { me, signOut } = useAuth();
  if (!me) return null; // RequireAuth guards this
  const t = me.tenants[0];
  return (
    <main className="min-h-screen px-6 py-12">
      <div className="mx-auto max-w-5xl">
        <header className="flex items-center justify-between">
          <div>
            <p className="text-xs uppercase tracking-widest text-sky-400">Workspace</p>
            <h1 className="mt-1 text-2xl font-semibold">{t ? t.name : 'No workspace'}</h1>
            {t && (
              <p className="text-slate-400 text-sm">
                {t.slug}.clarity.app &middot; {t.tier} tier &middot; {t.status}
              </p>
            )}
          </div>
          <div className="text-sm text-slate-400 flex items-center gap-4">
            <span>{me.user.email}</span>
            <button onClick={signOut} className="underline hover:text-slate-200">
              Sign out
            </button>
          </div>
        </header>

        {!t ? (
          <section className="mt-12 rounded-lg border border-amber-700/40 bg-amber-900/10 p-6">
            <h2 className="text-lg font-semibold">No workspace yet</h2>
            <p className="mt-2 text-slate-400">
              You&apos;re logged in but haven&apos;t subscribed to a tier.{' '}
              <a className="text-sky-400 hover:underline" href="https://clarity.app/signup">
                Start with Pilot — $149/mo
              </a>
              .
            </p>
          </section>
        ) : (
          <section className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Link
              to="/wrap-config"
              className="block rounded-lg border border-slate-800 bg-slate-900/50 p-6 hover:border-sky-500"
            >
              <h3 className="font-semibold">Wrap config</h3>
              <p className="mt-2 text-sm text-slate-400">
                Configure your engine: copy, pricing, ICP labels, output format.
              </p>
            </Link>
            <Link
              to="/ai-cto"
              className="block rounded-lg border border-slate-800 bg-slate-900/50 p-6 hover:border-sky-500"
            >
              <h3 className="font-semibold">AI-CTO chat</h3>
              <p className="mt-2 text-sm text-slate-400">
                Ask the AI-CTO about decisions, scope, costs.
              </p>
            </Link>
            <Link
              to="/costs"
              className="block rounded-lg border border-slate-800 bg-slate-900/50 p-6 hover:border-sky-500"
            >
              <h3 className="font-semibold">Costs</h3>
              <p className="mt-2 text-sm text-slate-400">
                View your product cost breakdown from last month.
              </p>
            </Link>
            <Link
              to="/audit"
              className="block rounded-lg border border-slate-800 bg-slate-900/50 p-6 hover:border-sky-500"
            >
              <h3 className="font-semibold">Audit trail</h3>
              <p className="mt-2 text-sm text-slate-400">
                View all workspace activity — provisioning, config changes, AI-CTO messages.
              </p>
            </Link>
          </section>
        )}
      </div>
    </main>
  );
}
